import React, { useEffect, useRef, useState } from 'react';

import { Box } from '@material-ui/core';

import ActivationLinkWarning from './ActivationLinkWarning';

// Keeps the editor fully visible when the warning banner is shown by
// shrinking the editor container by the exact banner height. When the
// warning is hidden the original fixed height is preserved.
const BASE_EDITOR_HEIGHT = 'calc(100vh - 80px - 56px - 56px)';

const EmailEditorLayout = ({ form, editor, showWarning }) => {
  const warningRef = useRef(null);
  const [warningHeight, setWarningHeight] = useState(0);

  useEffect(() => {
    const measure = () => {
      setWarningHeight(
        warningRef.current ? warningRef.current.offsetHeight : 0
      );
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [showWarning]);

  return (
    <>
      {form}
      {showWarning && (
        <Box ref={warningRef} pb={2}>
          <ActivationLinkWarning />
        </Box>
      )}
      {/* Header plus two rows of input fields */}
      <Box
        height={
          warningHeight > 0
            ? `calc(${BASE_EDITOR_HEIGHT} - ${warningHeight}px)`
            : BASE_EDITOR_HEIGHT
        }
      >
        {editor}
      </Box>
    </>
  );
};

export default EmailEditorLayout;
